import { OrganizationContext } from '@/components/OrganizationProvider/OrganizationProvider';
import { requestsRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { RequestsKey } from './types';

export const useGetRequestsClaimants = () => {
  const { organizationId } = useContext(OrganizationContext);
  return useQuery({
    queryKey: [...RequestsKey.CLAIMANTS, organizationId],
    queryFn: () => {
      return requestsRepo.getRequestsClaimants();
    },
  });
};
